<div class="headline-text" mat-dialog-title>{{ conf?.title }}</div>
<div class="basic-text" mat-dialog-content>
  {{ conf?.message }}
</div>
<div mat-dialog-actions>
  <markant-button class="button pink big" style="margin: 0.5em" [mat-dialog-close]="'confirm'" cdkFocusInitial>Ok</markant-button>
  <markant-button class="button pink big" style="margin: 0.5em" [mat-dialog-close]="'cancel'">Abbrechen</markant-button>
</div>
